export default "__VITE_ASSET__DiIW1ARg__"